<script setup lang="ts">
const props = defineProps<{ label: string; data?: string | number | null }>()
const _data = computed(() => props.data ?? 'N/A')
</script>

<template>
  <div class="flex flex-col items-start">
    <div class="text-xs rounded-full text-primary leading-none mb-1">
      {{ label }}
    </div>
    <div class="font-bold">
      <template v-if="$slots.default">
        <slot />
      </template>

      <div
        v-else
        class="text-sm leading-none"
      >
        {{ _data }}
      </div>
    </div>
  </div>
</template>
